<div class="onboarding-step-wrapper">
    <h2>Enable banner branding</h2>
    <div class="onboarding-blurb">
        <p>Add your organisation's branding as a banner with basic background and text colour preferences.</p>
    </div>
    <ng-container *ngIf="!isLoading else showLoader">
        <div class="onboarding-prompt-wrapper">
            <ng-container *ngIf="active else showInactive">
                <p class="onboarding-prompt">Branding is on.<br/>Do you want to turn branding off?</p>
                <button (click)="submit(false)" class="cas-button-action">Turn off</button>
            </ng-container>

            <ng-template #showInactive>
                <p class="onboarding-prompt">Branding is off.<br/>Do you want to turn branding on?</p>
                <button (click)="submit(true)" class="cas-button-action">Turn on</button>
            </ng-template>
        </div>

        <ng-container *ngIf="active">
            <form [formGroup]="brandingForm" class="cas-flex-column cas-form-floating">
                <acabim-form-block labelWidth="14" [labelAlign]="'right'" [colonize]="true" class="push-up-2">
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Background colour</acabim-form-input-label>
                        <acabim-form-input-content [shortField]="true" note="(e.g. #fff for white)">
                            <input formControlName="brandingBannerColour" />
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Text colour</acabim-form-input-label>
                        <acabim-form-input-content [shortField]="true" note="(e.g. #000 for black)">
                            <input formControlName="brandingTextColour" />
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                </acabim-form-block>
            </form>
            <div class="button-bar">
                <button (click)="setColours()">Update</button>
            </div>
        </ng-container>

    </ng-container>

    <ng-template #showLoader>
        <acabim-loading-view></acabim-loading-view>
    </ng-template>

</div>





